import React from 'react';

import smartnicIcon from '@images/spe-low-level-programming/smartnic.svg';
import smartnicSettings from '@images/spe-low-level-programming/smartnic-settings.svg';
import smartnicUser from '@images/spe-low-level-programming/smartnic-user.svg';

export const smartNIC = {
  mainSection: {
    icon: smartnicIcon,
    elements: [
      {
        type: 'text',
        items: [
          <>
            SmartNICs allow you to perform advanced operations on packets. These include tunnel termination, applying
            sophisticated flow classification and filtering mechanisms on packets, traffic metering and shaping.
          </>,
          <></>,
          <>
            These functions have typically been performed by a CPU, but smartNIC allows you to offload them, increasing
            your network’s performance as the server can then focus on its primary tasks.
          </>,
          <></>,
          <>
            Common use cases for smartNICs include hyperscale cloud providers (like Google Cloud Platform, Amazon Web
            Services, Microsoft Azure), which use smartNICs to optimize data center performance, and telcos, which
            employ smartNICs to accelerate their VNF applications.
          </>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        icon: smartnicUser,
        title: 'For smartNIC users:',
        items: [
          <>Implement a desired network function using P4 (if it is supported by the given smartNIC)</>,
          <>
            Write eBPF programs to be executed within the host system or SmartNIC kernel for improving performance and
            the solution’s maintenance costs
          </>,
          <>Adapt the user&apos;s existing software (e.g. SDN controller) to control the given smartNIC at runtime</>,
        ],
      },
      {
        type: 'list',
        icon: smartnicSettings,
        title: 'For smartNIC manufactures:',
        items: [
          <>Develop firmware for smartNIC</>,
          <>Develop drivers (DPDK PMD or kernel module)</>,
          <>Offer QA—building automated test environments for performance and functional tests</>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Case study',
        items: [
          {
            title: 'Using ONOS SDN controller with P4-programmable smartNICs to offload VNFs',
            link: '/case-study/using-onos-sdn-controller-with-p4-programmable-smartnics-to-offload-vnfs/',
          },
        ],
      },
      {
        type: 'Video',
        items: [
          {
            title: 'P4-programmable smartNIC controlled by ONOS',
            link: '/blog/p4-programmable-smartnic-controlled-by-onos-video/',
          },
        ],
      },
      {
        type: 'Blog post',
        items: [
          {
            title: 'SmartNICs with P4 support',
            link: '/blog/smartnics-with-p4-support/',
          },
          {
            title: 'What are SmartNICs? The different types and features',
            link: '/blog/what-are-smartnics-the-different-types-and-features/',
          },
        ],
      },
    ],
  },
};
